import { useDispatch } from "react-redux";
import { useKeycloak } from '@react-keycloak/web';
import { useCallback } from "react";
import { getBoundingMediaPoints, getBoundingMediaPointsAuth } from "../../store/reducers/media.reducer";

export const useUpdateBoundingMediaPoints = () => {
	const dispatch = useDispatch();
	const { keycloak, initialized } = useKeycloak();

	const updateFunction = useCallback((bounds) => {
		if (!initialized) {
			console.warn("Update function called before Keycloak was initialized. Aborting.");
			return;
		}

		if (keycloak && keycloak.token) {
			console.log("Dispatching AUTH request via update function.");
			dispatch(getBoundingMediaPointsAuth({ bounds, token: keycloak.token }));
		} else {
			console.log("Dispatching PUBLIC request via update function.");
			dispatch(getBoundingMediaPoints(bounds));
		}
	}, [dispatch, keycloak, initialized]);

	return updateFunction;

	// return () => (southLat, northLat, westLong, eastLong) => {
	// 	const dispatch = useDispatch();

	// 	useEffect(() => {
	// 		dispatch(getBoundingMediaPoints(southLat, northLat, westLong, eastLong))
	// 	}, [dispatch]);

	// 	const boundingMediaPoints = useBoundingMediaPoints();

	// 	return boundingMediaPoints;
	// }
}

//   const useState = (initialValue) => {
//     if (!state.hasOwnProperty(stateIndex)) state[stateIndex] = initialValue;
//     const value = state[stateIndex];
//     const closureStateIndex = stateIndex;
//     const setterFunction = (newValue) => {
//       state[closureStateIndex] = newValue;
//       setTimeout(App);
//     };
//     stateIndex++;
//     return [value, setterFunction];
//   }